import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DynamicEntryComponent, DynamicEntryComponentCrmConfig, DynamicOptionsComponent } from '../dynamic-options';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AutomationVariableMenuComponent, insertVariable } from '../../../../../../common/components';
import { DataType } from '@vendasta/automata';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'automata-positive-integer',
  templateUrl: './float.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
  ],
})
export class FloatComponent implements OnInit, DynamicOptionsComponent, DynamicEntryComponent {
  numberInputControl = new FormControl<number | null>(null, Validators.required);
  selectedValue$ = this.numberInputControl.valueChanges;
  @Input() showVariableItemMenu: boolean;
  @Input() initialValue: number;
  @Input() label = 'AUTOMATIONS.COMMON.NUMBER';
  @Input() config: DynamicEntryComponentCrmConfig;
  public supportedDataTypes = [DataType.DATA_TYPE_NUMBER];
  id = uuidv4();

  ngOnInit(): void {
    if (this.initialValue !== null && this.initialValue !== undefined) {
      this.numberInputControl.setValue(this.initialValue);
    }
  }

  getSelectedValue(): number {
    return this.numberInputControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.numberInputControl];
  }

  isFormValid(): boolean {
    return this.numberInputControl.valid;
  }

  insertTheVariable(control: AbstractControl, variable: string): void {
    insertVariable(this.id, control, variable);
  }
}
